import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Адаптационные семинары</h1>
            </StartStep>
            <GreyCard>
                <p><b>Вы получите ответы на важные вопросы:</b></p>
                <ul>
                    <li>Каковы стратегия и перспективы развития НИУ ВШЭ?</li>
                    <li>Кадровая политика университета и логика ее развития.</li>
                    <li>Об организации науки и образовательного процесса в НИУ ВШЭ. Что важно знать об оценке
                        публикационной активности работников?
                    </li>
                    <li>Какие варианты повышения квалификации существуют в университете? Как включиться в программы
                        «Научный фонд», «Фонд образовательных инноваций», «Teach for HSE», «Академический кадровый
                        резерв» и мероприятия Центра академического письма? Что это дает?
                    </li>
                    <li>О правовых основах работы преподавателей и исследователей.</li>
                    <li>Как формируется заработная плата?</li>
                    <li>Ресурсы портала и другие сервисы для работников.</li>
                </ul>
                <br/>
                <p><a href="https://academics.hse.ru/hipo/adaptation">Адаптационные семинары</a><br/>
                    <a href="https://academics.hse.ru/hipo/adaptation/program2022">Программа адаптационного семинара —
                        2022</a>
                </p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step8">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={81}/>
                        <span>Шаг 9 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step10">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;